import { USStates, DriversResult, XDetailsResult } from './model';
import { Nullable } from 'common';

export const PREACRIS_SET_LOADING = 'PREACRIS_SET_LOADING';
export const RESET_DRIVERS_DATA = 'RESET_DRIVERS_DATA';
export const RESET_RESULTS = 'RESET_RESULTS';
export const PREACRIS_RESULT_SUCCESS = 'PREACRIS_RESULT_SUCCESS';
export const GET_PREACRIS_STATES_SUCCESS = 'GET_PREACRIS_STATES_SUCCESS';
export const GET_PREACRIS_DRIVERS_SUCCESS = 'GET_PREACRIS_DRIVERS_SUCCESS';
export const GET_PREACRIS_XDETAILS_SUCCESS = 'GET_PREACRIS_XDETAILS_SUCCESS';
export const RESET_XDETAILS_DATA = 'RESET_XDETAILS_DATA';

export interface PreacrisState {
  loading: boolean;
  usStates: Nullable<USStates>;
  driversData: Nullable<DriversResult>;
  xdetailsData: Nullable<XDetailsResult>;
}

export interface SetResultLoadingType {
  type: typeof PREACRIS_SET_LOADING;
  loading: boolean;
}

export interface ResetResultsType {
  type: typeof RESET_RESULTS;
}

export interface GetStatesSuccessType {
  type: typeof GET_PREACRIS_STATES_SUCCESS;
  usStates: USStates;
}
export interface ResetDriversDataType {
  type: typeof RESET_DRIVERS_DATA;
}
export interface ResetXDetailsDataType {
  type: typeof RESET_XDETAILS_DATA;
}
export interface GetDriversSuccessType {
  type: typeof GET_PREACRIS_DRIVERS_SUCCESS;
  driversData: DriversResult;
}
export interface GetXDetailsSuccessType {
  type: typeof GET_PREACRIS_XDETAILS_SUCCESS;
  xdetailsData: XDetailsResult;
}
export type PreacrisTypes =
  | SetResultLoadingType
  | ResetResultsType
  | GetStatesSuccessType
  | ResetDriversDataType
  | GetDriversSuccessType
  | ResetXDetailsDataType
  | GetXDetailsSuccessType;
